import { render, staticRenderFns } from "./CommunityProfilePreview.vue?vue&type=template&id=315a8872&scoped=true&"
import script from "./CommunityProfilePreview.vue?vue&type=script&lang=ts&"
export * from "./CommunityProfilePreview.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityProfilePreview.vue?vue&type=style&index=0&id=315a8872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a8872",
  null
  
)

export default component.exports